import { EXPERIMENT_IDENTIFIERS } from '~server/routes/Pricing/experimentsConfig';
import defaultRules from './defaultRules';

import GROW_2529_FEATURE_RULES from '~pricing/experiments/grow_2529_forms/transformers/details/featureRules';
import GROW_2792_FEATURE_RULES from '~pricing/experiments/grow_2792_pnp_refresh_v1/transformers/details/groupings/featureRules';

import { DetailsFeatureRulesMap } from '../types';
import { PackageType } from '~shared/types/pricing/package';

const detailsFeatureRules: DetailsFeatureRulesMap = {
  [PackageType.Teams]: {
    default: defaultRules,
    [EXPERIMENT_IDENTIFIERS.GROW_2792.treatment]: { ...defaultRules, ...GROW_2792_FEATURE_RULES },
  },
  [PackageType.Details]: {
    default: defaultRules,
    [EXPERIMENT_IDENTIFIERS.GROW_2792.treatment]: { ...defaultRules, ...GROW_2792_FEATURE_RULES },
  },
  [PackageType.Individual]: {
    default: defaultRules,
    [EXPERIMENT_IDENTIFIERS.GROW_2529_FORMS.treatment1]: { ...defaultRules, ...GROW_2529_FEATURE_RULES },
    [EXPERIMENT_IDENTIFIERS.GROW_2529_FORMS.treatment2]: { ...defaultRules, ...GROW_2529_FEATURE_RULES },
    [EXPERIMENT_IDENTIFIERS.GROW_2629_FORMS_V2.treatment]: { ...defaultRules, ...GROW_2529_FEATURE_RULES },
    [EXPERIMENT_IDENTIFIERS.GROW_2792.treatment]: { ...defaultRules, ...GROW_2792_FEATURE_RULES },
  },
  [PackageType.Educational]: {
    default: defaultRules,
  },
};

export default detailsFeatureRules;
